import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class ForesightDirectLinkToAnalysisGuard  {
    constructor(private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): UrlTree {
        let urlTree = this.router.createUrlTree([`/project`]);
        const queryParams: RequiredParams = route.queryParams;
        if (this.hasRequiredParams(queryParams)) {
            urlTree = this.router.createUrlTree([`/foresight/${queryParams.projectId}/chrome-extension`], { queryParams });
        }
        return urlTree;
    }

    private hasRequiredParams(queryParams: RequiredParams): boolean {
        return !!queryParams.objectId && !!queryParams.projectId;
    }
}

interface RequiredParams {
    projectId?: string;
    objectId?: string;
}
